import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import React from 'react';
import { ButtonLink, LinkProps } from '../Link';

interface Props extends Omit<LinkProps, 'ref'> {
  to: string;
}

const SkipLink = React.forwardRef<HTMLAnchorElement, Props>(({ children, ...props }, ref) => {
  if (!props.to?.startsWith('#')) {
    throw new Error('Skip link href is required and must begin with #.');
  }

  const location = useLocation();

  return (
    <div className="pds-max-w-xs">
      <ButtonLink
        ref={ref}
        onClick={() => {
          navigate(props.to, {
            replace: false,
            state: location.state as Record<string, unknown>,
          });
        }}
        {...props}
        className="pds-sr-only pds-z-[9999] pds-bg-surface-layer pds-text-surface-text focus:pds-not-sr-only focus:pds-h-full"
      >
        {children}
      </ButtonLink>
    </div>
  );
});

export default SkipLink;
